const COST_PER_1000_ITEMS_FOR_SCRAPING = 2.5;
const COST_PER_1000_ITEMS_FOR_ANALYSIS = 7;
const COST_PER_1000_ITEMS = COST_PER_1000_ITEMS_FOR_SCRAPING + COST_PER_1000_ITEMS_FOR_ANALYSIS;

export function calculateExpectedCostForScraping(itemCountToScrape: number) {
  const expectedCost = (itemCountToScrape / 1000) * COST_PER_1000_ITEMS;
  return Math.round(expectedCost * 10) / 10;
}
